/* src/app/components/input-phone-with-county-code/custom-modal-with-country-selection/custom-modal-with-country-selection.component.scss */
.wrapper {
  padding: 20px;
}
.wrapper .header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0px 20px;
}
.wrapper .header ion-icon {
  fill: white;
  color: white;
}
.wrapper .country-list {
  width: 100%;
  padding: 10px 0px;
  max-height: 400px;
  overflow: auto;
}
.wrapper .country-list .country {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
  background: white;
  border-radius: 10px;
  margin: 10px 0px;
}
.wrapper .country-list .country ion-icon {
  width: 25px;
  padding-right: 10px;
}
.wrapper .country-list .country h3 {
  width: calc(100% - 55px);
  font-family: Tusker, sans-serif;
  font-size: 14px;
  text-align: left;
}
.wrapper .country-list .country .selected-circle {
  width: 25px;
  height: 25px;
  background: transparent;
  border: 2.5px solid var(--ion-color-secondary);
  border-radius: 50%;
  position: relative;
}
.wrapper .country-list .country .selected-circle .inner-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 15px;
  height: 15px;
  background: var(--ion-color-secondary);
  border-radius: 50%;
  visibility: hidden;
  opacity: 0;
}
.wrapper .country-list .country .selected-circle .inner-circle.show {
  visibility: visible;
  opacity: 1;
  transition: ease-in-out 0.5s;
}
/*# sourceMappingURL=custom-modal-with-country-selection.component.css.map */
